/* ============================================================
   PW Quote — volumen geometrico por mapa de profundidad

   QUE HACE
   Duplica la foto en 3 planos y los separa en Z dentro de la escena 3D
   que la seccion ya tiene. Al girar la escena, los planos se desplazan a
   distinta velocidad: eso es el paralaje, y es lo que se lee como
   volumen de verdad.

   POR QUE SE CONSTRUYE AQUI Y NO SE SUBEN 3 PNG
   Medido: 3 capas exportadas pesan 2.729 KB frente a los 1.494 KB de la
   foto actual (+83%). El mapa de profundidad solo pesa 140 KB (+9%) y
   con el se cortan las capas en un canvas, una vez. Misma imagen final,
   una decima parte del peso anadido.

   POR QUE LAS CAPAS SON ACUMULATIVAS Y NO BANDAS EXCLUSIVAS
   El primer intento uso bandas con peso coseno centradas en 0,52 / 0,74
   / 0,90. Medido despues: el 80,4% de los pixeles del borde suave perdia
   mas del 30% de su alfa, porque el borde del pelo tiene profundidad
   casi 0 y ninguna banda llegaba ahi. Con composicion "over", tres
   mascaras que suman 1 NO reconstruyen el original: 1-(1-a)^3 se queda
   corto siempre.

   La solucion es acumular: el plano del fondo lleva la foto ENTERA a
   alfa completa, y los de delante solo anaden las zonas mas cercanas.
   Asi el alfa compuesto es siempre >= al original y ningun pixel puede
   desaparecer, pase lo que pase con el mapa.

   DONDE NO SE EJECUTA
   En tactil y con prefers-reduced-motion: ni se descarga el mapa.
   ============================================================ */
if (!window.pwCita3dCargado) {
  window.pwCita3dCargado = true;

  function pwSuave(x, a, b) {
    var t = Math.max(0, Math.min(1, (x - a) / (b - a)));
    return t * t * (3 - 2 * t);
  }

  function pwCita3dInit() {
    var cfg = document.querySelector('[data-pw-cita3d]');
    if (!cfg || cfg.dataset.pwListo) return;
    if (!window.matchMedia('(hover: hover)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var mapaUrl = cfg.getAttribute('data-mapa');
    if (!mapaUrl) return;
    var fuerza = parseFloat(cfg.getAttribute('data-fuerza')) || 60;

    var wrap = document.querySelector('[id$="__pw-cita"] .pw-cita-fadewrap');
    var img = wrap && wrap.querySelector('img');
    if (!img) return;
    cfg.dataset.pwListo = '1';

    function cargar(u) {
      return fetch(u, { mode: 'cors' })
        .then(function (r) { return r.blob(); })
        .then(createImageBitmap);
    }

    function arrancar() {
      var origen = img.currentSrc || img.src;
      Promise.all([cargar(origen), cargar(mapaUrl)])
        .then(function (r) { construir(r[0], r[1]); })
        .catch(function () { /* si algo falla, la foto original se queda intacta */ });
    }

    function construir(foto, mapa) {
      var W = foto.width, H = foto.height, N = W * H;

      var cf = document.createElement('canvas'); cf.width = W; cf.height = H;
      var gf = cf.getContext('2d', { willReadFrequently: true });
      gf.drawImage(foto, 0, 0);
      var src = gf.getImageData(0, 0, W, H);

      /* El mapa viaja a 512px porque es suave y no necesita mas. */
      var cm = document.createElement('canvas'); cm.width = W; cm.height = H;
      var gm = cm.getContext('2d', { willReadFrequently: true });
      gm.imageSmoothingQuality = 'high';
      gm.drawImage(mapa, 0, 0, W, H);
      var prof = gm.getImageData(0, 0, W, H).data;

      /* capa 0 = foto entera (garantiza cobertura total)
         capa 1 = de profundidad media hacia delante
         capa 2 = solo lo mas cercano */
      var capas = [
        { a: -1,   b: -1,   z: -1 },
        { a: 0.62, b: 0.80, z: 0.35 },
        { a: 0.80, b: 0.95, z: 1 }
      ];

      var cont = document.createElement('div');
      cont.className = 'pw-cita3d';

      capas.forEach(function (c) {
        var cv = document.createElement('canvas');
        cv.width = W; cv.height = H;
        var g = cv.getContext('2d');
        if (c.a < 0) {
          g.drawImage(foto, 0, 0);
        } else {
          var im = new ImageData(new Uint8ClampedArray(src.data), W, H);
          for (var i = 0; i < N; i++) {
            var a0 = im.data[i * 4 + 3];
            if (a0 === 0) continue;
            im.data[i * 4 + 3] = a0 * pwSuave(prof[i * 4] / 255, c.a, c.b);
          }
          g.putImageData(im, 0, 0);
        }
        cv.className = 'pw-cita3d__plano';
        cv.style.setProperty('--pw-z', (c.z * fuerza).toFixed(1) + 'px');
        cont.appendChild(cv);
      });

      wrap.appendChild(cont);
      wrap.classList.add('pw-cita3d--on');
    }

    /* No es critico: se espera a que la pagina termine para no competir
       con el LCP. */
    if (document.readyState === 'complete') arrancar();
    else window.addEventListener('load', arrancar);
  }

  pwCita3dInit();
  document.addEventListener('DOMContentLoaded', pwCita3dInit);
  document.addEventListener('shopify:section:load', pwCita3dInit);
}
